module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/TabbedContent-a5b54e1a72453ae33ae745e229fd7dd9.png";